import { Services } from '.';
const routes = [
    {
        path: '/services',
        element: <Services />,
        title: 'Services'
    }
]

export default routes;